import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 上传
 * @param {} file
 */
export function uoloadFilesq(formData) {
    return axios({
        url: api + "/finance/uploadSq",
        method: "post",
        data: formData,
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });
}

/**
 * 申请提交
 */
export function addDissent({ companyName, uscc, xxType, yysjx, cause, annex, tableName, tableId }) {
    return axios.post(
        api + "/creditDissent/insert",
        qs.stringify({
            companyName,
            uscc,
            xxType,
            yysjx,
            cause,
            annex,
            tableName,
            tableId
        })
    );
}

/**
 * 检查企业信用档案下载次数
 * @returns {AxiosPromise<any>}
 */
export function checkDowload(companyId) {
    return axios.get(api + "/company/checkDowloadCompanyRecord",{
        params:{
            companyId
        }
    })
}

/**
 * 获取企业信用档案最大下载次数
 * @returns {AxiosPromise<any>}
 */
export function getMaxDowload() {
    return axios.get(api + "/company/getMaxDowloadTimes")
}

/**
 * 设置企业信用档案最大下载次数
 * @returns {AxiosPromise<any>}
 */
export function setMaxDowload({maxDowloadTimes}) {
    return axios.get(api + "/company/setMaxDowload", {
        params:{
            maxDowloadTimes
        }
    })
}

export function getMyReport(companyId) {
    return axios.post(api + "/creditReport/getMyReport", qs.stringify({
        companyId
    }));
}
